import Button from "../ui/Button";
import { AppleIcon, GoogleIcon } from "../ui/icons";

export function OAuthSectionWrapper({ children, className = "" }) {
  return (
    <section
      aria-label="Continue with a social account"
      className={`my-[30px] mb-[10px] flex flex-col items-center justify-center ${className}`}
    >
      {children}
    </section>
  );
}

// Social buttons use the design system's secondary variant (light tint surface,
// dark label) per Figma 87657:22683. Logos are currentColor glyphs so they track
// the label color in light and dark mode.
const OAuthIcon = {
  apple: AppleIcon,
  google: GoogleIcon,
};

const OAuthButton = ({ service, onClick, children, loading = false, ...rest }) => {
  const Icon = OAuthIcon[service];
  return (
    <Button
      variant="secondary"
      className="w-full"
      isLoading={loading}
      onClick={onClick}
      {...rest}
    >
      {Icon && <Icon size={20} />}
      {children}
    </Button>
  );
};

export default OAuthButton;
